<template>
    <div :class="['notificator', { 'selected': dash.includes(selectedNotificators, notificator.id) }]">
        <div v-if="notificator.type == 'email'">
            <i class="fal fa-at"></i>
            <strong>{{ type }}</strong> {{ notificator.properties.EmailAddress }}
        </div>
        <div v-else-if="notificator.type == 'webhook'">
            <i class="fal fa-server"></i>
            {{ notificator }}
        </div>
        <div v-else-if="notificator.type == 'sms'">
            <i class="fal fa-comments"></i>
            {{ notificator }}
        </div>
        <div v-else-if="notificator.type == 'telegram'">
            <i class="fab fa-telegram-plane"></i>
            <img width="64" :src="notificator.properties.photo_url" />
            <p>User id: {{ notificator.properties.id }}</p>
        </div>
        <div v-else-if="notificator.type == 'slack'">
            <i class="fab fa-slack"></i>
            {{ notificator }}
        </div>
        <div v-else-if="notificator.type == 'pushbullet'">
            <i class="fab fa-pushbullet"></i>
            {{ notificator }}
        </div>

        <button
            class="btn btn-link edit-notificator-button"
            v-on:click.capture.stop.prevent="invokeNotificatorEditorModal(notificator.id)">
            <i class="fa fa-cog"></i>
        </button>
    </div>
</template>

<script>
export default {
    props: ['notificator', 'selectedNotificators'],
    name: 'notificators',
    data() {
        return  {
            notificators: [{test: "one"}],
            dash: window._
        }
    },
    methods: {
      invokeNotificatorEditorModal(id) {
        this.$modal.show('notificator-editor', { notificator_id: id});
      }
   },
    computed: {
      type() {
        return this.notificator.type.toUpperCase()
      }
    }
}
</script>

<style lang="scss">
    .notificator {
        border: 1px solid #d2d2d2;
        border-radius: 2px;
        padding: 11px 19px;
        width: 100%;
        box-shadow: 2px 2px 10px #f1f1f1;
        position: relative;

        &.selected {
            border: 1px solid #1e729c;
            background: #00a9ff;
            color: #fff;
        }

        &:active {
            background: #eee;
        }

        &:hover {
            border: 1px solid #1e729c;
            cursor: pointer;
        }


        .edit-notificator-button {
            position: absolute;
            top: 10px;
            right: 10px;
        }
    }
</style>




// WEBPACK FOOTER //
// src/components/Notificators.vue